import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { deleteJob, fetchData, getJobs } from '../../API/annotatorApi';
import { useHistory } from 'react-router-dom';
import { getAdvices } from '../../API/advices';
import { Button, ButtonGroup } from 'react-bootstrap';
import Loader from 'react-loader-advanced';
import Oval from 'react-loader-spinner';

function SearchJobsComponent() {
  const [jobsData, setJobsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const statusType = { '-1': 'Failed', '0': 'Pending', '1': 'Created' };
  let history = useHistory();

  const search = async (jobID, data_length, pageNumber = 0) => {
    try {
      setIsLoading(true);
      let response = await fetchData(jobID, pageNumber);
      let response_data = response;

      response = {
        title: "Search",
        projectName: "Search",
        laufzeit: "Heute",
        parsedlv_id: "None",
        data_length: data_length,
        OZ: response_data.map(item => item.OZ),
        annotations: {
          annotations: response_data.flatMap(item => item.annotations),
          lv_document: response_data.filter(item => item.lvDocument !== null && item.lvDocument !== undefined).map(item => item.lvDocument)
        }
      };
      let advices = await getAdvices();
      advices = advices.response;
      let annots = response.annotations;
      if (response) {
        history.push(process.env.REACT_APP_FRONTEND_PATH_DATATOOLVIEWPAGE, {
          jobID: jobID,
          data_length: response.data_length,
          lvstatus: 'search',
          lvList: { data: response },
          annotationData: annots,
          links: {
            efb221CDNLink: '',
            vhb211CDNLink: 'project.vhb211',
            vhb213CDNLink: 'project.vhb213',
            vhb214CDNLink: 'project.vhb214',
          },
          adviceList: advices,
          projectFirm: response.projectName,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const delete_job = (job_id) => {
    if (confirm(`Really delete Job ${job_id}?`)) {
      setJobsData([...jobsData.filter((job) => job["job_id"] !== job_id)]);
      deleteJob(job_id);
    }
  }

  const formatDate = (date) => {
    return new Date(date + 'Z').toLocaleString('de-DE', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        let newJobs = await getJobs();
        newJobs = newJobs.response;

        const newJobsDataValues = newJobs.map((o) => ({
          job_id: o.job_id,
          term: o.term,
          category: o.cat_exclude ? `Not in ${o.category}` : o.category,
          industry: o.industry,
          hinweis_only: (o.hinweis_only ?? false) ? 'yes': 'no',
          completed_only: (o.completed_only ?? false) ? 'yes': 'no',
          length: o.length ?? '-',
          timestamp: formatDate(o.timestamp),
          status: statusType[o.status.toString()],
          action: (
              <ButtonGroup>
                <Button key={`view-button-${o.job_id}`}
                        size="sm"
                        className="btn btn-info"
                        disabled={o.status !== 1 || o.length === 0}
                        style={{marginRight: "3px"}}
                        onClick={() => search(o.job_id, o.length)}>
                  View
                </Button>
                <Button key={`delete-button-${o.job_id}`}
                        size="sm"
                        className="btn btn-info"
                        //disabled={o.status === 0}
                        onClick={() => delete_job(o.job_id)}>
                  Delete
                </Button>
              </ButtonGroup>
          ),
        }));

        setJobsData(newJobsDataValues);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchJobs();

    const intervalId = setInterval(fetchJobs, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const columns = [
    { Header: 'JOB ID', accessor: 'job_id' },
    { Header: 'TERM', accessor: 'term' },
    { Header: 'CATEGORY', accessor: 'category' },
    { Header: 'INDUSTRY', accessor: 'industry' },
    { Header: "HEADLINES ONLY", accessor: 'hinweis_only'},
    { Header: "COMPLETED ONLY", accessor: 'completed_only'},
    { Header: 'TIMESTAMP', accessor: 'timestamp' },
    { Header: 'LENGTH', accessor: 'length' },
    { Header: 'STATUS', accessor: 'status' },
    { Header: 'ACTION', accessor: 'action' },
  ];

  return (
    <Loader
          show={isLoading}
          message={<span>
              <Oval
                  visible={true}
                  height="80"
                  width="80"
                  color="#ffffff"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  type="Oval" /></span>}
      >
      <div className="container handwai-dark">
        <table className="table advicesTableText">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.Header}>{column.Header}</th>
              ))}
            </tr>
          </thead>
          <tbody style={{ backgroundColor: 'white' }}>
            {jobsData.map((row) => (
              <tr key={row.job_id} style={row['status'] === 'Failed' ? {backgroundColor: "orange"} : null}>
                {columns.map((column) => (
                  <td key={column.Header} style={{padding: "5px", verticalAlign: "middle"}}>{row[column.accessor]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Loader>
  );
}

export default SearchJobsComponent;